import { render, staticRenderFns } from "./LayoutNotification.vue?vue&type=template&id=663c02d3&"
import script from "./LayoutNotification.vue?vue&type=script&lang=ts&"
export * from "./LayoutNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports